/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { notebookitem } from './subs/notebookitem';

export class notebookpage extends IceEntity {
  notebook_page_key: string = "";
  nbpage_name: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  ITEMS: notebookitem[] = [];

  constructor(attr: any = {}) {
    super();
    for (let colName of Object.keys(attr)) {
      if (attr[colName] == null) continue;
      this.attributes[colName] = attr[colName];
    }
  }

  public gettablename(): string {
    return "NOTEBOOK_PAGE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ITEMS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ITEMS") return "NOTEBOOK_ITEM";

    return null;
  }
}
